import classNames from 'classnames';
import { Children, cloneElement, useCallback } from 'react';

import useStyles from './styles';
import { IButtonToggle } from './types';

function ButtonToggle({ children, value, className, disabled = false, onChange }: IButtonToggle) {
  const len = children.length;
  const step = 100 / len;
  const currentIndex = children.findIndex(({ props }) => value === props.value);

  const classes = useStyles({
    selectedPosition: currentIndex * step,
    selectedWidth: 100 / len,
    disabled,
  });

  const handleOnSelect = useCallback(
    (selectedValue: string) => {
      if (!disabled) {
        onChange(selectedValue);
      }
    },
    [disabled, onChange],
  );

  return (
    <div className={classNames(classes.outer, className, disabled ? 'disabled' : '')}>
      <div className={classes.root}>
        {Children.map(children, (child) => cloneElement(child, { onSelect: handleOnSelect }))}

        <span className={classes.selected}></span>
      </div>
    </div>
  );
}

export default ButtonToggle;
